<div class="px-0 container-fluid container-box">
    <div class="row justify-content-center">
        <div class="col-10 px-0">
            <div class="d-flex justify-content-between align-items-center">
                <span class="font-12 text-light-gray">
                    <ng-container *ngIf="data?.importConsignment;else OtherCondition">
                      <i class="fst-normal text-danger">*</i> Properties required to create consignment:
                    </ng-container>
                    <ng-template #OtherCondition>
                      <i class="fst-normal text-danger">*</i> Properties required
                    </ng-template>
                </span>
                <app-button
                  class="px-0"
                  [button_2]="true"
                  [buttonClass]="'button button-info mx-0'"
                  [buttonLable]="enumButtonName.TEMPLATE_SETTING"
                  (click)="openTemplateSettingModal()">
                </app-button>
              </div>
              <app-ag-grid class="center-Pagination d-block position-relative minHeightSet" [ngStyle]="{'height': flexHeight}"
                [dataModel]="dataModel" [rowData]="data?.mapData?.rowData" [paginations]="false" [columnSettings]="false"
                (gridReady)="onGridReady($event)">
              </app-ag-grid>
              <app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;"
                [isLoaderLoading]="isLoading"></app-custom-loader>
              </div>
        </div>
      </div>
      <div>
  </div>
  